import { useContext } from 'react';
import { useIdleLogout } from './useIdleLogout';
import { AuthCtx } from '../context/AuthContext';

/* sólo activa el hook cuando existe sesión */
export function IdleLogoutHandler() {
  const { token, logout } = useContext(AuthCtx);
  useIdleLogout({ enabled: !!token, onLogout: logout });
  return null;
}